import { getProxyUrl } from '@proxies/index'
import { resolveUnitApiBaseUrl } from '@utils/catalog/kbrCatalog'
import { Api } from './myApi'

type ApiOptions = {
  catalogID?: string | number | null
  idUnidades?: number | null
  /** @deprecated Ya no redirige a planificador3dapi; se ignora. */
  forceTpc?: boolean
}

export function API(options?: ApiOptions) {
  const token = { Authorization: 'Ninpo ' + sessionStorage.getItem('access_token') }

  // KBR usa la misma API del proyecto que el resto (no planificador3dapi).
  const forcedBase = resolveUnitApiBaseUrl(options?.catalogID, options?.idUnidades)
  let baseUrl = forcedBase || getProxyUrl('')

  // Normalizar la URL - asegurar que termine con /
  baseUrl = baseUrl.replace(/\/+$/, '') + '/'

  return new Api({
    baseApiParams: { headers: token },
    baseUrl: baseUrl,
  })
}
